<template>
  <div class="container-fluid">
    <div class="row">
      <layout-left-auth />

      <div class="col-md-5">
        <div class="container h-full d-flex align-items-center justify-content-center flex-column">
          <div class="row d-flex flex-column text-center align-items-center">
            <img src="../../assets/img/blue-logo.png" class="logo-mobile-auth d-sm-none" />
            <div class="forgot-title">Forgot your password?</div>
            <div class="forgot-undertitle">Enter your email to reset the password</div>
          </div>

          <form @submit.prevent="send" @keydown="clearError($event)" autocomplete="no" class="new-auth-form">
            <div class="material-textfield">
              <input v-model="user.email"
                     id="email"
                     name="email"
                     type="text"
                     class=""
                     placeholder=" "
                     autofocus
              />
              <label>Email</label>
            </div>

            <error-field :errors="errors" field="email" class="material-errors" />
            <error-field :errors="errors" field="exception" class="material-errors" />
            <error-field :errors="errors" field="credentials" class="material-errors" />
            <input type="submit" class="btn btn-primary login-button reset-btn hover-btn-bg"
                   value="Reset password"
                   :disabled="errors.any()"
            />
          </form>

          <div class="row">
            <div class="col">
              <router-link class="back-link" to="/login">Go back to login</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import LayoutLeftAuth from './components/LayoutLeftAuth';

export default {
  components: {
    ErrorField,
    LayoutLeftAuth,
  },
  data: () => ({
    user: {
      email: '',
    },
    errors: new Errors(),
  }),
  methods: {
    ...mapActions(['sendMailForResetPassword']),
    send() {
      this.sendMailForResetPassword({ ...this.user })
        .then(() => {
          this.$router.push('/reset-password-email-sent');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    clearError(event) {
      if (this.errors.has('exception')) {
        this.errors.clear('exception');
      }
      this.errors.clear(event.target.name);
    },
  },
};
</script>
<style scoped>
.forgot-title {
  font-weight: 500;
  font-size: 40px;
  line-height: 48px;
  text-align: center;
  letter-spacing: -0.72px;
  color: #131c36;
  margin-bottom: 7px;
}
.forgot-undertitle {
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #3e475e;
  margin-bottom: 45px;
}
.forgot-form {
}

.login-input {
  background: rgba(239, 239, 239, 0.2);
  border: 1px solid rgba(97, 97, 97, 0.1);
  border-radius: 3px;
  font-size: 16px;
  line-height: 20px;
  /* identical to box height, or 125% */
  color: #616161;
}
.forgot-input {
  margin-bottom: 40px;
}
.reset-btn {
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  width: 318px;
  color: #fff;
  background: #2962ff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
}
.back-link {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.0875px;
  color: #2962ff;
}
@media only screen and (max-width: 480px) {
  .forgot-title {
    font-size: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/auth/ForgotPassword.vue